<template>
  <div class="page_ruleSet">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="项目" size="small">
              <el-select v-model="listQuery.projectId" placeholder="" style="width:180px" filterable @change="getList">
                <el-option label="全部" :value="0"></el-option>
                <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态" size="small">
              <el-select v-model="listQuery.status" placeholder="" style="width:180px" filterable @change="getList">
                <el-option label="启用" :value="0"></el-option>
                <el-option label="禁用" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>AI小杰</el-breadcrumb-item>
          <el-breadcrumb-item>{{activeName=='5' ? '入职参保规则' : '入职签约规则'}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="杰小薪设置" name="0"></el-tab-pane>
          <el-tab-pane label="杰小职设置" name="1"></el-tab-pane>
          <el-tab-pane label="杰小金设置" name="2"></el-tab-pane>
          <el-tab-pane label="任务缺省设置" name="3"></el-tab-pane>
          <!-- <el-tab-pane label="增强学习" name="4"></el-tab-pane> -->
          <el-tab-pane label="入职参保规则" name="5"></el-tab-pane>
          <el-tab-pane label="入职签约规则" name="6"></el-tab-pane>
        </el-tabs>

        <div class="ftabBtn flex">
          <!-- <el-button type="primary" size="small">导出</el-button> -->
          <el-button type="success" size="small" @click="addInsureSet" v-if="activeName=='5'">添加项目配置</el-button>
          <el-button type="success" size="small" @click="addEleSet" v-if="activeName=='6'">添加项目配置</el-button>
          <!-- <el-button type="danger" size="small">删除项目配置</el-button> -->
        </div>
        <el-table :data="tableData" border class="doc_table" @selection-change="handleSelectionChange" :max-height="tableHeight-100" v-loading="loading" style="width:100%">
          <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column>
          <el-table-column prop="projectName" label="项目" min-width="140" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="insuranceType" key="2" label="满足条件：险种（代码）" min-width="380" :show-overflow-tooltip="true" align="center" v-if="activeName=='5'">
            <template slot-scope="{row}">
              <div class="cell_newline">{{ row.insuranceType }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="positionType" key="3" label="岗位|职业类别" min-width="240" :show-overflow-tooltip="true" align="center" v-if="activeName=='5'">
            <template slot-scope="{row}">
              <div class="cell_newline">{{ row.positionType }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="employeeAttributes" key="4" label="员工属性" min-width="240" :show-overflow-tooltip="true" align="center" v-if="activeName=='5'">
            <template slot-scope="{row}">
              <div class="cell_newline">{{ row.employeeAttributes }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="conditions" key="5" label="入职 满足条件 | 签约模板 | 合同/协议类型 | 合同时长" min-width="500" align="center" v-if="activeName=='6'">
            <template slot-scope="{row}">
              <div class="cell_newline">{{ row.conditions }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="resignationConditions" key="6" label="离职 满足条件 | 签约模板 | 合同/协议类型" min-width="500" align="center" v-if="activeName=='6'">
            <template slot-scope="{row}">
              <div class="cell_newline">{{ row.resignationConditions }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="status" key="7" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column label="操作" align="center" width="200" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="editInsureSet(row)" v-if="activeName=='5'">编辑</el-button>
                <el-button type="text" size="small" @click="editEleHandel(row)" v-if="activeName=='6'">编辑入职规则</el-button>
                <el-button type="text" size="small" @click="editQuitHandel(row)" v-if="activeName=='6'">编辑离职规则</el-button>
                <el-button type="text" size="small" @click="stopHandle(row,row.status=='启用'?1:0)">{{ row.status=='启用' ? '禁用' : '启用' }}</el-button>
                <el-popconfirm title="请确定是否作废" @confirm="delHandle(row)">
                  <el-button type="text" slot="reference" style="margin-left: 10px;">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 入职签约规则 -->
    <el-dialog :title="type=='add' ? '添加项目配置' : '修改'" :visible.sync="addVisible" width="1100px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="ruleForm" :model="ruleForm" class="" label-width="60px" size="small" v-if="addEleVisible">
        <el-form-item label="项目:" prop="projectId">
          <el-select v-model="ruleForm.projectId" placeholder="" style="width:180px" filterable @change="changePro">
            <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
          </el-select>
        </el-form-item>

        <el-table :data="ruleForm.typesOfInsurance" border class="doc_table" style="width:100%">
          <el-table-column prop="personnelCondition" label="人员情况" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="满足条件" min-width="200" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <div v-if="ruleForm.typesOfInsurance.length>0">
                <div v-if="row.personnelCondition=='按年龄范围'">{{ row.年龄范围.最小年龄 + '岁 ≤ 年龄 ＜' + row.年龄范围.最大年龄}}</div>
                <div v-if="row.personnelCondition=='按岗位'">{{ row.岗位}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="template" label="签约模板" min-width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="agreement" label="合同/协议类型" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="duration" label="协议期限" min-width="80" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.duration + row.unit }}</template>
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope="{$index}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="delItem(ruleForm.typesOfInsurance,$index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="setItem flex">
          <el-select v-model="typesOfInsurance.personnelCondition" placeholder="人员情况" size="small" style="width:110px;margin-right: 15px;" @change="(val)=>{changeType(val,'typesOfInsurance')}">
            <el-option value="缺省"></el-option>
            <el-option value="按年龄范围"></el-option>
            <el-option value="按岗位"></el-option>
          </el-select>

          <div class="yearBox flex" v-if="typesOfInsurance.personnelCondition=='按年龄范围'">
            <el-input v-model="typesOfInsurance.年龄范围.最小年龄" size="small" style="width:45px;margin-right: 5px;"></el-input>
            <div>岁 ≤年龄＜ </div>
            <el-input v-model="typesOfInsurance.年龄范围.最大年龄" size="small" style="width:45px;margin-right: 5px;"></el-input>
            <div>岁</div>
          </div>
          <el-input v-model="typesOfInsurance.岗位" v-if="typesOfInsurance.personnelCondition=='按岗位'" placeholder="请输入岗位" size="small" style="width:140px;margin-right: 15px;"></el-input>

          <el-select v-model="typesOfInsurance.ContractSubject" placeholder="请选择签约主体" size="small" style="width:180px;margin-right: 15px;" filterable>
            <el-option v-for="(item,index) in legList" :key="index" :value="item.CompanyName"></el-option>
          </el-select>

          <el-select v-model="typesOfInsurance.TempId" placeholder="请选择模板" clearable filterable style="width:180px;margin-right: 15px;" value-key="TempName" :disabled="!ruleForm.projectId" size="small" @change="changeTemp">
            <el-option v-for="(item,index) in tempList" :key="index" :label="item.TempName" :value="item.TempId"></el-option>
          </el-select>

          <el-select v-model="typesOfInsurance.agreement" value-key="name" placeholder="合同/协议列表" clearable filterable size="small" style="width:120px;margin-right: 15px;">
            <el-option v-for="(item,index) in contractList" :key="index" :value="item.name"></el-option>
          </el-select>

          <el-input v-model="typesOfInsurance.duration" placeholder="" size="small" style="width:60px;margin-right: 5px;" type="number"></el-input>
          <el-select v-model="typesOfInsurance.unit" value-key="name" placeholder="" size="small" style="width:60px;margin-right: 15px;">
            <el-option value="年"></el-option>
            <el-option value="月"></el-option>
            <el-option value="日"></el-option>
          </el-select>

          <div class="flex aic cp addBox" style="margin-left:10px" @click="addRule4">
            <i class="el-icon-circle-plus icon01"></i>
            <el-button type="text" style="margin-left:5px">添加</el-button>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addEleVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAdd" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="字段赋值" :visible.sync="showFieldSet" width="800px" class="res_dialog enter_dialog">
      <div class="container">
        <div class="table-header">
          <div>签约字段</div>
          <div>来源</div>
          <div>数据源字段</div>
        </div>
        <div class="field-row" v-for="(field, index) in fieldData" :key="index">
          <div class="field-name">{{ field.key }}</div>
          <div>
            <el-select v-model="fieldForm.data[index].source" placeholder="" style="width:180px" filterable @change="(val)=>{changeSource(val,field)}" size="small">
              <el-option :label="getLabel(op.source)" :value="op.source" v-for="(op,i) in field.item2" :key="i"></el-option>
            </el-select>
          </div>
          <div>
            <!-- 输入框 -->
            <el-input v-model="fieldForm.data[index].inputContent" placeholder="" size="small" style="width:180px;margin-right: 5px;" v-if="field.inputType=='string'"></el-input>
            <!-- 数字 -->
            <el-input v-model="fieldForm.data[index].inputContent" placeholder="" size="small" type="number" style="width:180px;margin-right: 5px;" v-if="field.inputType=='number'"></el-input>
            <!-- 下拉选择 -->
            <el-select v-model="fieldForm.data[index].inputContent" placeholder="" style="width:180px" filterable size="small" v-if="field.inputType=='select'">
              <el-option :label="item.value" :value="item.key" v-for="(item,i) in field.dic" :key="i"></el-option>
            </el-select>
            <!-- 日期 -->
            <el-date-picker v-model="fieldForm.data[index].inputContent" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;" v-if="field.inputType=='date'">
            </el-date-picker>

            <!-- source==2/3 时，数据源字段 -->
            <el-select v-model="fieldForm.data[index].dataSourceNo" placeholder="" style="width:180px" filterable size="small" v-if="fieldForm.data[index].source==2">
              <el-option :label="item.value" :value="item.key" v-for="(item,i) in optionList2" :key="i"></el-option>
            </el-select>
            <el-select v-model="fieldForm.data[index].dataSourceNo" placeholder="" style="width:180px" filterable size="small" v-if="fieldForm.data[index].source==3">
              <el-option :label="item.value" :value="item.key" v-for="(item,i) in optionList3" :key="i"></el-option>
            </el-select>
            <el-select v-model="fieldForm.data[index].dataSourceNo" placeholder="" style="width:180px" filterable size="small" v-if="fieldForm.data[index].source==4">
              <el-option :label="item.value" :value="item.key" v-for="(item,i) in optionList4" :key="i"></el-option>
            </el-select>
            <el-select v-model="fieldForm.data[index].dataSourceNo" placeholder="" style="width:180px" filterable size="small" v-if="fieldForm.data[index].source==5">
              <el-option :label="item.value" :value="item.key" v-for="(item,i) in optionList5" :key="i"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showFieldSet = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmSetField" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="添加项目配置" :visible.sync="addInsureVisible" width="550px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="ruleForm" :model="ruleForm" class="" label-width="120px" size="small" v-if="addInsureVisible">
        <el-form-item label="项目:" prop="projectId">
          <el-select v-model="ruleForm.projectId" placeholder="" style="width:300px" filterable @change="changePro">
            <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="参保法务主体:" prop="subjectType">
          <el-radio-group v-model="ruleForm.subjectType" @input="changeSubjectType">
            <el-radio :label="1">按个人签约法务主体</el-radio>
            <el-radio :label="2">指定法务主体</el-radio>
          </el-radio-group>
          <el-select v-model="ruleForm.subjectId" placeholder="" style="width:300px;" value-key="Id" filterable v-if="ruleForm.subjectType==2">
            <el-option v-for="item in legList" :key="item.Id" :label="item.CompanyName" :value="item.Id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="默认险种:" prop="insuranceType">
          <el-select v-model="ruleForm.insuranceType" placeholder="" size="small" style="width:300px" @change="(val)=>{changeInsurance2(val,'typesOfInsurance')}" filterable>
            <el-option v-for="(item,index) in insureList" :key="index" :label="item.Bntype" :value="item.InsuranceCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="默认职业类别:" prop="positionType">
          <el-select v-model="ruleForm.positionType" placeholder="" size="small" style="width:300px">
            <el-option value="1-4类"></el-option>
            <el-option value="5类"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="默认员工属性:" prop="employeeAttributes">
          <el-select v-model="ruleForm.employeeAttributes" placeholder="" size="small" style="width:300px">
            <el-option value="长期工"></el-option>
            <el-option value="临时工"></el-option>
            <el-option value="日结工"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addInsureVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAddSet('SetInsuranceRulesAdd')" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑项目配置" :visible.sync="editInsureVisible" width="850px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="ruleForm" :model="ruleForm" class="" label-width="60px" size="small" v-if="editInsureVisible">
        <el-form-item label="项目:" prop="projectId">
          <el-select v-model="ruleForm.projectId" placeholder="" style="width:300px" filterable>
            <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
          </el-select>
        </el-form-item>

        <div class="formTitle formTitle2"><span>|</span> 险种设置 </div>
        <el-table :data="insuranceTypesList" border class="doc_table" style="width:100%">
          <el-table-column label="人员情况" min-width="300" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row,$index}">
              <div v-if="$index==0">缺省</div>
              <span v-else class="flex" style="justify-content: center;">
                <span>
                  <span v-if="row.minage && row.minage">{{ row.minage + '岁 ≤ 年龄 ＜' + row.maxage }}</span>
                  <span v-else>年龄不限</span>
                </span>
                <span style="margin-left: 5px;">
                  <span v-if="row.position!=null && row.position.length>0">| {{ row.position.toString()}}</span>
                  <span v-else>| 岗位不限</span>
                </span>
                <span style="margin-left: 5px;">
                  <span v-if="row.gender">| {{ row.gender==1 ? '男' : '女'}}</span>
                  <span v-else>| 性别不限</span>
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="text" label="险种名称" min-width="300" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope="{$index}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="delItem(insuranceTypesList,$index)" v-if="$index!=0">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 新增险种条件 -->
        <div class="setItem">
          <div class="yearBox flex">
            <el-checkbox v-model="typesOfInsurance.age">年龄条件:</el-checkbox>
            <el-input v-model="typesOfInsurance.minage" size="small" style="width:80px;margin:0 5px 0 15px"></el-input>
            <div>岁 ≤ 年龄 ＜</div>
            <el-input v-model="typesOfInsurance.maxage" size="small" style="width:80px;margin:0 5px"></el-input>
            <div>岁</div>

            <div class="tips">提示：不勾选则为此项条件不限</div>
          </div>

          <div class="yearBox flex">
            <el-checkbox v-model="typesOfInsurance.job">岗位条件:</el-checkbox>
            <el-select v-model="typesOfInsurance.position" placeholder="请选择岗位" size="small" style="width:300px;margin: 0 5px 0 15px;" filterable clearable multiple>
              <el-option v-for="(item,index) in jobData" :key="index" :value="item.value"></el-option>
            </el-select>
          </div>

          <div class="yearBox flex">
            <el-checkbox v-model="typesOfInsurance.sex">性别条件:</el-checkbox>
            <el-select v-model="typesOfInsurance.gender" placeholder="请选择性别" size="small" style="width:300px;margin: 0 5px 0 15px;" filterable clearable>
              <el-option label="男" :value="1"></el-option>
              <el-option label="女" :value="2"></el-option>
            </el-select>
          </div>

          <div class="flex">
            <el-select v-model="typesOfInsurance.value" placeholder="请选择险种" size="small" style="width:300px" @change="(val)=>{changeInsurance(val,'typesOfInsurance')}" filterable>
              <el-option v-for="(item,index) in insureList" :key="index" :label="item.Bntype" :value="item.InsuranceCode"></el-option>
            </el-select>

            <div class="flex aic cp addBox" style="margin-left:10px" @click="addRule">
              <i class="el-icon-circle-plus icon01"></i>
              <el-button type="text" style="margin-left:5px">添加</el-button>
            </div>
          </div>
        </div>

        <div class="formTitle formTitle2"><span>|</span> 参保岗位和职业类别设置 </div>
        <el-table :data="jobAndCategoryList" border class="doc_table" style="width:100%">
          <el-table-column label="人员情况" min-width="500" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row,$index}">
              <div v-if="$index==0">缺省</div>
              <span v-else class="flex" style="justify-content: center;">
                <span>
                  <span v-if="row.minage && row.minage">{{ row.minage + '岁 ≤ 年龄 ＜' + row.maxage }}</span>
                  <span v-else>年龄不限</span>
                </span>
                <span style="margin-left: 5px;">
                  <span v-if="row.position!=null && row.position.length>0">| {{ row.position.toString()}}</span>
                  <span v-else>| 岗位不限</span>
                </span>
                <span style="margin-left: 5px;">
                  <span v-if="row.gender">| {{ row.gender==1 ? '男' : '女'}}</span>
                  <span v-else>| 性别不限</span>
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="value" label="职业类别" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope="{$index}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="delItem(jobAndCategoryList,$index)" v-if="$index!=0">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 新增职业类别条件 -->
        <div class="setItem">
          <div class="yearBox flex">
            <el-checkbox v-model="jobAndCategory.age">年龄条件:</el-checkbox>
            <el-input v-model="jobAndCategory.minage" size="small" style="width:80px;margin:0 5px 0 15px"></el-input>
            <div>岁 ≤ 年龄 ＜</div>
            <el-input v-model="jobAndCategory.maxage" size="small" style="width:80px;margin:0 5px"></el-input>
            <div>岁</div>

            <div class="tips">提示：不勾选则为此项条件不限</div>
          </div>

          <div class="yearBox flex">
            <el-checkbox v-model="jobAndCategory.job">岗位条件:</el-checkbox>
            <el-select v-model="jobAndCategory.position" placeholder="请选择岗位" size="small" style="width:300px;margin: 0 5px 0 15px;" filterable clearable multiple>
              <el-option v-for="(item,index) in jobData" :key="index" :value="item.value"></el-option>
            </el-select>
          </div>

          <div class="yearBox flex">
            <el-checkbox v-model="jobAndCategory.sex">性别条件:</el-checkbox>
            <el-select v-model="jobAndCategory.gender" placeholder="请选择性别" size="small" style="width:300px;margin: 0 5px 0 15px;" filterable clearable>
              <el-option label="男" :value="1"></el-option>
              <el-option label="女" :value="2"></el-option>
            </el-select>
          </div>

          <div class="flex">
            <el-select v-model="jobAndCategory.value" placeholder="请选择职业类别" size="small" style="width:300px" filterable>
              <el-option value="1-4类"></el-option>
              <el-option value="5类"></el-option>
            </el-select>

            <div class="flex aic cp addBox" style="margin-left:10px" @click="addRule2">
              <i class="el-icon-circle-plus icon01"></i>
              <el-button type="text" style="margin-left:5px">添加</el-button>
            </div>
          </div>
        </div>

        <div class="formTitle formTitle2"><span>|</span> 员工属性设置 </div>
        <el-table :data="employeeAttributeList" border class="doc_table" style="width:100%">
          <el-table-column label="人员情况" min-width="500" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row,$index}">
              <div v-if="$index==0">缺省</div>
              <span v-else class="flex" style="justify-content: center;">
                <span>
                  <span v-if="row.minage && row.minage">{{ row.minage + '岁 ≤ 年龄 ＜' + row.maxage }}</span>
                  <span v-else>年龄不限</span>
                </span>
                <span style="margin-left: 5px;">
                  <span v-if="row.position!=null && row.position.length>0">| {{ row.position.toString()}}</span>
                  <span v-else>| 岗位不限</span>
                </span>
                <span style="margin-left: 5px;">
                  <span v-if="row.gender">| {{ row.gender==1 ? '男' : '女'}}</span>
                  <span v-else>| 性别不限</span>
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="value" label="员工属性" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope="{$index}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="delItem(employeeAttributeList,$index)" v-if="$index!=0">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 新增员工属性设置条件 -->
        <div class="setItem">
          <div class="yearBox flex">
            <el-checkbox v-model="employeeAttribute.age">年龄条件:</el-checkbox>
            <el-input v-model="employeeAttribute.minage" size="small" style="width:80px;margin:0 5px 0 15px"></el-input>
            <div>岁 ≤ 年龄 ＜</div>
            <el-input v-model="employeeAttribute.maxage" size="small" style="width:80px;margin:0 5px"></el-input>
            <div>岁</div>

            <div class="tips">提示：不勾选则为此项条件不限</div>
          </div>

          <div class="yearBox flex">
            <el-checkbox v-model="employeeAttribute.job">岗位条件:</el-checkbox>
            <el-select v-model="employeeAttribute.position" placeholder="请选择岗位" size="small" style="width:300px;margin: 0 5px 0 15px;" filterable clearable multiple>
              <el-option v-for="(item,index) in jobData" :key="index" :value="item.value"></el-option>
            </el-select>
          </div>

          <div class="yearBox flex">
            <el-checkbox v-model="employeeAttribute.sex">性别条件:</el-checkbox>
            <el-select v-model="employeeAttribute.gender" placeholder="请选择性别" size="small" style="width:300px;margin: 0 5px 0 15px;" filterable clearable>
              <el-option label="男" :value="1"></el-option>
              <el-option label="女" :value="2"></el-option>
            </el-select>
          </div>

          <div class="flex">
            <el-select v-model="employeeAttribute.value" placeholder="请选择员工属性" size="small" style="width:300px" filterable>
              <el-option value="长期工"></el-option>
              <el-option value="临时工"></el-option>
              <el-option value="日结工"></el-option>
            </el-select>

            <div class="flex aic cp addBox" style="margin-left:10px" @click="addRule3">
              <i class="el-icon-circle-plus icon01"></i>
              <el-button type="text" style="margin-left:5px">添加</el-button>
            </div>
          </div>
        </div>

        <div class="formTitle formTitle2"><span>|</span> 参保法务主体设置 </div>

        <el-form-item label="参保法务主体:" label-width="110px">
          <el-radio-group v-model="ruleForm.subjectType" @input="changeSubjectType">
            <el-radio :label="1">按个人签约法务主体</el-radio>
            <el-radio :label="2">指定法务主体</el-radio>
          </el-radio-group>
          <el-select v-model="ruleForm.subjectId" placeholder="" style="width:300px;margin-left: 10px;" value-key="Id" filterable v-if="ruleForm.subjectType==2">
            <el-option v-for="item in legList" :key="item.Id" :label="item.CompanyName" :value="item.Id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editInsureVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmEditInsureSet" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 入职签约规则 -->
    <el-dialog title="添加项目配置" :visible.sync="addEleVisible" width="550px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="ruleForm" :model="ruleForm" class="" label-width="160px" size="small" v-if="addEleVisible">
        <el-form-item label="项目:" prop="projectId">
          <el-select v-model="ruleForm.projectId" placeholder="" style="width:300px" filterable @change="changePro">
            <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="默认签约主体:" prop="signingCompany">
          <el-select v-model="ruleForm.signingCompany" placeholder="" style="width:300px;" filterable>
            <el-option v-for="(item,index) in legList" :key="index" :label="item.CompanyName" :value="item.Id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="默认签约模板:" prop="templateId">
          <el-select v-model="ruleForm.templateId" placeholder="" clearable filterable style="width:300px;margin-right: 15px;" value-key="TempName" size="small" @change="changeTemp" :disabled="!ruleForm.projectId">
            <el-option v-for="(item,index) in tempList" :key="index" :label="item.TempName" :value="item.TempId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="默认合同协议类型:" prop="agreementType">
          <el-select v-model="ruleForm.agreementType" value-key="name" placeholder="" clearable filterable size="small" style="width:300px;margin-right: 15px;">
            <el-option v-for="(item,index) in contractList" :key="index" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="默认合同期限:" prop="deadline">
          <div class="flex">
            <el-input v-model="ruleForm.deadline" placeholder="请输入时长" size="small" style="width:140px;" type="number"></el-input>
            <el-select v-model="ruleForm.unit" value-key="name" placeholder="请选择单位" size="small" style="width:140px;margin-left: 10px;">
              <el-option label="年" :value="1"></el-option>
              <el-option label="月" :value="2"></el-option>
              <el-option label="日" :value="3"></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="离职默认模板:" prop="lTemplateId">
          <el-select v-model="ruleForm.lTemplateId" placeholder="" clearable filterable style="width:300px;margin-right: 15px;" value-key="TempName" size="small" @change="changeTemp2">
            <el-option v-for="(item,index) in tempList" :key="index" :label="item.TempName" :value="item.TempId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="离职默认合同协议类型:" prop="lAgreementType">
          <el-select v-model="ruleForm.lAgreementType" value-key="name" placeholder="" clearable filterable size="small" style="width:300px;margin-right: 15px;">
            <el-option v-for="(item,index) in contractList" :key="index" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addEleVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAddSet('SetSigningRulesAdd')" size="small" :loading="isbtnLoading">确定</el-button>
      </span>
    </el-dialog>



    <el-dialog :title="type=='quit' ? '编辑离职职签约配置' : '编辑入职签约配置'" :visible.sync="editEleVisible" width="1050px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="ruleForm" :model="ruleForm" class="" label-width="60px" size="small" v-if="editEleVisible">
        <el-form-item label="项目:" prop="projectId">
          <el-select v-model="ruleForm.projectId" placeholder="" style="width:300px" filterable>
            <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
          </el-select>
        </el-form-item>

        <el-table :data="insuranceTypesList" border class="doc_table" style="width:100%">
          <el-table-column label="人员情况" min-width="300" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row,$index}">
              <div v-if="$index==0">缺省</div>
              <span v-else class="flex" style="justify-content: center;">
                <span>
                  <span v-if="row.minage && row.minage">{{ row.minage + '岁 ≤ 年龄 ＜' + row.maxage }}</span>
                  <span v-else>年龄不限</span>
                </span>
                <span style="margin-left: 5px;">
                  <span v-if="row.position!=null && row.position.length>0">| {{ row.position.toString()}}</span>
                  <span v-else>| 岗位不限</span>
                </span>
                <span style="margin-left: 5px;">
                  <span v-if="row.gender">| {{ row.gender==1 ? '男' : '女'}}</span>
                  <span v-else>| 性别不限</span>
                </span>
                <span style="margin-left: 5px;" v-if="type=='entry'">
                  <span v-if="row.workType!=undefined && row.workType">| {{ WorkTypeList[row.workType].text }}</span>
                  <span v-else>| 员工属性不限</span>
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="签约主体" min-width="160" :show-overflow-tooltip="true" align="center" v-if="type!='quit'">
            <template slot-scope="{row}">
              {{ getLegalSubjectName(row.signingCompany) }}
            </template>
          </el-table-column>
          <el-table-column prop="templateName" label="签约模板" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="agreementType" label="合同/协议类型" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="协议期限" min-width="100" :show-overflow-tooltip="true" align="center" v-if="type!='quit'">
            <template slot-scope="{row}">{{ row.deadline }}{{ row.unit=='1' ? '年' :  row.unit=='2' ? '月' : '日'}}</template>
          </el-table-column>
          <el-table-column label="操作" min-width="160" align="center">
            <template slot-scope="{row,$index}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="fieldSet(row)" v-if="row.conditionsId">字段赋值</el-button>
                <el-button type="text" size="small" @click="delItem(insuranceTypesList,$index)" v-if="$index!=0">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 新增险种条件 -->
        <div class="setItem">
          <div class="yearBox flex">
            <el-checkbox v-model="typesOfInsurance.age">年龄条件:</el-checkbox>
            <el-input v-model="typesOfInsurance.minage" size="small" style="width:80px;margin:0 5px 0 15px"></el-input>
            <div>岁 ≤ 年龄 ＜</div>
            <el-input v-model="typesOfInsurance.maxage" size="small" style="width:80px;margin:0 5px"></el-input>
            <div>岁</div>

            <div class="tips">提示：不勾选则为此项条件不限</div>
          </div>

          <div class="yearBox flex">
            <el-checkbox v-model="typesOfInsurance.job">岗位条件:</el-checkbox>
            <el-select v-model="typesOfInsurance.position" placeholder="请选择岗位" size="small" style="width:300px;margin: 0 5px 0 15px;" filterable clearable multiple>
              <el-option v-for="(item,index) in jobData" :key="index" :value="item.value"></el-option>
            </el-select>
          </div>

          <div class="yearBox flex">
            <el-checkbox v-model="typesOfInsurance.sex">性别条件:</el-checkbox>
            <el-select v-model="typesOfInsurance.gender" placeholder="请选择性别" size="small" style="width:300px;margin: 0 5px 0 15px;" filterable clearable>
              <el-option label="男" :value="1"></el-option>
              <el-option label="女" :value="2"></el-option>
            </el-select>
          </div>

          <div class="yearBox flex">
            <el-checkbox v-model="typesOfInsurance.work">用工属性:</el-checkbox>
            <el-select v-model="typesOfInsurance.workType" placeholder="请选择用工属性" size="small" style="width:300px;margin: 0 5px 0 15px;" filterable clearable>
              <el-option v-for="(item,index) in WorkTypeList" :key="index" :label="item.text" :value="item.value"></el-option>
            </el-select>
          </div>

          <div class="flex">
            <el-select v-model="typesOfInsurance.signingCompany" placeholder="请选择签约主体" size="small" style="width:240px;margin-right: 15px;" filterable clearable v-if="type!='quit'">
              <el-option v-for="(item,index) in legList" :key="index" :label="item.CompanyName" :value="item.Id"></el-option>
            </el-select>

            <el-select v-model="typesOfInsurance.templateId" placeholder="请选择模板" clearable filterable style="width:240px;margin-right: 15px;" value-key="TempName" size="small" @change="changeTemp3">
              <el-option v-for="(item,index) in tempList" :key="index" :label="item.TempName" :value="item.TempId"></el-option>
            </el-select>

            <el-select v-model="typesOfInsurance.agreementType" value-key="name" placeholder="合同/协议列表" clearable filterable size="small" style="width:180px;margin-right: 15px;">
              <el-option v-for="(item,index) in contractList" :key="index" :value="item.name"></el-option>
            </el-select>

            <el-input v-model="typesOfInsurance.deadline" placeholder="协议期限" size="small" style="width:100px;margin-right: 5px;" type="number" v-if="type!='quit'"></el-input>
            <el-select v-model="typesOfInsurance.unit" value-key="name" placeholder="单位" size="small" style="width:100px;margin-right: 15px;" v-if="type!='quit'">
              <el-option label="年" :value="1"></el-option>
              <el-option label="月" :value="2"></el-option>
              <el-option label="日" :value="3"></el-option>
            </el-select>

            <div class="flex aic cp addBox" style="margin-left:10px" @click="addRule4">
              <i class="el-icon-circle-plus icon01"></i>
              <el-button type="text" style="margin-left:5px">添加</el-button>
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editEleVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmEditEleSet" size="small" :loading="isbtnLoading" v-if="type=='entry'">确定</el-button>
        <el-button type="primary" @click="confirmEditQuitSet" size="small" :loading="isbtnLoading" v-if="type=='quit'">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import {
    create,
    row
  } from "mathjs";
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: []
          },
          ProjectId: 0,
          status: 0,
          userId: Cookies.get("userid-b"),
        },
        ruleForm: {
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          id: '',
          taskType: 10, //10入职参保规则 20入职签约规则
          projectId: null,
          projectName: '',
          status: '启用',
          insuranceId: '', //险种id
          typesOfInsurance: '', //险种内容/签约内容（满足条件）
          jobAndCategory: '', //参保岗位和职业类别
          employeeAttribute: '', //员工属性
          subjectType: 1,
          subjectName: '',
        },
        type: '',
        fileList: [],
        addVisible: false,
        isbtnLoading: false,
        showDropScreen: -1,
        activeName: '0',
        num1: 0,
        tableData: [],
        expandTable: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        projectList: [], //项目列表
        multipleSelection: [],
        permissionLists: [],
        rules: {
          projectId: {
            required: true,
            message: "请选择项目",
            trigger: "change",
          },
          subjectType: {
            required: true,
            message: "请选择参保法务主体",
            trigger: "change",
          },
          insuranceType: {
            required: true,
            message: "请选择默认险种",
            trigger: "change",
          },
          positionType: {
            required: true,
            message: "请选择默认职业类别",
            trigger: "change",
          },
          employeeAttributes: {
            required: true,
            message: "请选择默认员工属性",
            trigger: "change",
          },
          signingCompany: {
            required: true,
            message: "请选择默认签约主体",
            trigger: "change",
          },
          employeeAttributes: {
            required: true,
            message: "请选择默认签约模板",
            trigger: "change",
          },
          templateId: {
            required: true,
            message: "请选择默认员工属性",
            trigger: "change",
          },
          agreementType: {
            required: true,
            message: "请选择默认合同协议类型",
            trigger: "change",
          },
          deadline: {
            required: true,
            message: "请选择默认合同期限",
            trigger: "change",
          },
          lTemplateId: {
            required: true,
            message: "请选择离职默认模板",
            trigger: "change",
          },
          lAgreementType: {
            required: true,
            message: "请选择离职默认合同协议类型",
            trigger: "change",
          }
        },
        typesOfInsurance: {}, //满足条件：险种（代码）
        jobAndCategory: {}, //岗位？|职业类别
        employeeAttribute: {}, //员工属性
        insureList: [], //险种列表
        addEleVisible: false,
        legList: [],
        contractList: this.$store.state.EMP.contractList, //合同/协议列表
        tempList: [],
        showFieldSet: false,
        fieldData: [],
        fieldForm: [],
        optionList2: [],
        optionList3: [],
        optionList4: [],
        optionList5: [],
        projectId: null,
        addInsureVisible: false,
        editInsureVisible: false,
        insuranceTypesList: [],
        jobAndCategoryList: [],
        employeeAttributeList: [],
        editEleVisible: false,
        WorkTypeList: [{
            value: 0,
            text: '无'
          }, {
            value: 1,
            text: 'Y社会工'
          },
          {
            value: 2,
            text: 'Y实习生'
          },
          {
            value: 3,
            text: 'Y学生短期工'
          },
          {
            value: 4,
            text: 'Y兼职工'
          },
          {
            value: 5,
            text: 'Y劳务工'
          },
          {
            value: 6,
            text: 'P社会工'
          },
          {
            value: 7,
            text: 'P社会工sdh'
          },
          {
            value: 8,
            text: 'P实习生'
          },
          {
            value: 9,
            text: 'P学生短期工'
          },
          {
            value: 10,
            text: 'P兼职工'
          }
        ],
        fieldSetForm: {},
        jobData: [],
      }
    },
    created() {
      if (this.$route.query.activeName != undefined && this.$route.query.activeName) {
        this.activeName = this.$route.query.activeName;
        this.changeTab()
      } else {
        this.getList();
      }
      this.getProList();
      this.getbIlist();
      this.getLegalSubjectList();
      this.GetDataSourceNo(2, 'optionList2');
      this.GetDataSourceNo(3, 'optionList3');
      this.GetDataSourceNo(4, 'optionList4');
      this.GetDataSourceNo(5, 'optionList5');
      // this.getButtonPower();
    },
    methods: {
      checkPermission,
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.projectList = res.msg;
          } else {
            this.projectList = [];
          }
        });
      },
      //取签约主体列表
      getLegalSubjectList() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      //获取商保列表
      getbIlist() {
        let d = {
          ProjectName: '', //商保方案名称
          Bntype: '', //商保类别
          TypeWork: '', //工种类型
          pageNum: 1,
          pageSize: 100
        }
        xz.getInsurancManageList(d).then(res => {
          if (res.status == 'ok') {
            this.insureList = res.data.data;
          } else {
            this.$message.error('获取险种列表失败')
            this.insureList = [];
          }
        })
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      getList() {
        let pagename = this.activeName == '5' ? 'GetInsuranceRulesList' : 'GetSigningRulesList'
        this.loading = true;
        xz.TaskSetupFun(this.listQuery, pagename).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      down(url) {
        var path = this.$store.state.EMP.imgPath + url;
        const aTag = document.createElement("a");
        aTag.href = path;
        aTag.click();
      },
      changeTab() {
        if (this.activeName == '0' || this.activeName == '1' || this.activeName == '2') {
          this.$router.push({
            path: '/settlementTask',
            query: {
              activeName: this.activeName
            }
          })
        } else if (this.activeName == '3') {
          this.$router.push({
            path: '/taskSet'
          })
        } else if (this.activeName == '4') {
          this.$router.push({
            path: '/dict'
          })
        } else if (this.activeName == '5' || this.activeName == '6') {
          this.getList()
        }
      },
      addInsureSet() {
        this.isbtnLoading = false;
        this.ruleForm = {
          projectId: null,
          subjectType: 1, //主体类别
          subjectId: '', //主体id
          insuranceType: '', //默认险种
          insuranceName: '', //默认险种名称
          positionType: '', //默认职业类别
          employeeAttributes: '', //默认员工属性
          userId: Cookies.get("userid-b")
        }
        this.addInsureVisible = true;
      },
      confirmAddSet(pagename) {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            this.isbtnLoading = true;
            xz.TaskSetupFun(this.ruleForm, pagename).then(res => {
              if (res.status == 'ok') {
                this.getList();
                this.isbtnLoading = false;
                this.$message.success('保存成功！');
                this.addInsureVisible = false;
                this.addEleVisible = false;
              } else {
                this.isbtnLoading = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      editInsureSet(row) {
        let str = `GetInsuranceRules?ProjectId=${row.projectId}`;
        xz.TaskSetupGetFun(str).then(res => {
          if (res.status == 'ok') {
            this.ruleForm = res.data;
            this.ruleForm.userId = Cookies.get("userid-b");
            // 险种设置
            this.typesOfInsurance = {
              value: '',
              text: '',
              minage: null,
              maxage: null,
              gender: null, //性别1：男2：女（未勾选不要传
              position: '',
              sex: false,
              age: false,
              job: false,
            };
            this.insuranceTypesList = res.data.insuranceTypes;
            let d = {
              text: res.data.insuranceName,
            }
            this.insuranceTypesList.unshift(d);

            // 职业类别设置
            this.jobAndCategory = {
              value: '',
              text: '',
              minage: null,
              maxage: null,
              gender: null, //性别1：男2：女（未勾选不要传
              position: '',
              sex: false,
              age: false,
              job: false,
            }
            this.jobAndCategoryList = res.data.positionTypes;
            let d2 = {
              value: res.data.positionType,
            }
            this.jobAndCategoryList.unshift(d2);
            // 员工属性设置
            this.employeeAttribute = {
              value: '',
              text: '',
              minage: null,
              maxage: null,
              gender: null, //性别1：男2：女（未勾选不要传
              position: '',
              sex: false,
              age: false,
              job: false,
            }
            this.employeeAttributeList = res.data.employeeAttributess;
            let d3 = {
              value: res.data.employeeAttributes,
            }
            this.employeeAttributeList.unshift(d3);
            this.getJobData(res.data.projectId);
            this.editInsureVisible = true;
          } else {

          }
        })
      },
      //编辑商保设置
      confirmEditInsureSet() {
        if (this.typesOfInsurance.value) {
          this.addRule();
        }
        if (this.jobAndCategory.value) {
          this.addRule2();
        }
        if (this.employeeAttribute.value) {
          this.addRule3();
        }
        this.ruleForm.insuranceTypes = JSON.parse(JSON.stringify(this.insuranceTypesList));
        this.ruleForm.insuranceTypes.shift();
        this.ruleForm.positionTypes = JSON.parse(JSON.stringify(this.jobAndCategoryList));
        this.ruleForm.positionTypes.shift();
        this.ruleForm.employeeAttributess = JSON.parse(JSON.stringify(this.employeeAttributeList));
        this.ruleForm.employeeAttributess.shift();

        this.isbtnLoading = true;
        xz.TaskSetupFun(this.ruleForm, 'SetInsuranceRulesEdit').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.isbtnLoading = false;
            this.$message.success('保存成功！');
            this.editInsureVisible = false;
          } else {
            this.isbtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      changePro() {
        let item = this.projectList.find(e => e.Projectid == this.ruleForm.projectId);
        let projectName = item.StrprojectName;
        if (this.activeName == '6') {
          xz.templatesByProjectList(projectName, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.tempList = res.data.tempList;
            } else {
              this.tempEleList = [];
            }
          })
        }
      },
      // 表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      batchRefresh() {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          this.multipleSelection.forEach((e, i) => {
            arr.push(e.projectId)
            if (i == this.multipleSelection.length - 1) {
              let d = arr.toString();
              this.confirmRefresh(d);
            }
          });
        } else {
          this.$message.warning('请至少选择一条')
        }
      },
      stopHandle(row, type) {
        this.loading = true;
        let d = {
          projectId: row.projectId,
          status: type,
          userId: Cookies.get("userid-b"),
        }
        let pagename;
        if (this.activeName == '5') {
          pagename = 'SetInsuranceRulesStatus';
        } else if (this.activeName == '6') {
          pagename = 'SetSigningRulesStatus';
        }
        xz.TaskSetupFun(d, pagename).then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.getList();
            this.$message.success("操作成功！");
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      delHandle(row) {
        this.loading = true;
        let str;
        if (this.activeName == '5') {
          str = `SetInsuranceRulesStatus?ProjectId=${row.projectId}`;
        } else {
          str = `SetSigningRulesStatus?ProjectId=${row.projectId}`;
        }
        xz.TaskSetupGetFun(str, 'DELETE').then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.getList();
            this.$message.success("作废成功！");
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      changeType(val, list) {
        console.log(val, list)
        if (val == '缺省') {
          this[list].参保岗位 = '';
          this[list].年龄范围 = null;
        } else if (val == '按年龄范围') {
          this[list].参保岗位 = '';
          this[list].年龄范围 = {
            最小年龄: '',
            最大年龄: ''
          };
        } else if (val == '按岗位') {
          this[list].年龄范围 = null;
        }
      },
      changeInsurance(val) {
        let item = this.insureList.find(e => e.InsuranceCode == val)
        this.typesOfInsurance.text = item.Bntype;
      },
      changeInsurance2(val) {
        let item = this.insureList.find(e => e.InsuranceCode == val)
        this.ruleForm.insuranceName = item.Bntype;
      },
      //添加险种设置
      addRule() {
        if (!this.typesOfInsurance.value) {
          this.$message.warning('请选择险种！');
        } else if (!this.typesOfInsurance.sex && !this.typesOfInsurance.age && !this.typesOfInsurance.job) {
          this.$message.warning('请至少勾选一个条件！');
        } else {
          let d = {
            value: this.typesOfInsurance.value,
            text: this.typesOfInsurance.text,
            minage: this.typesOfInsurance.minage,
            maxage: this.typesOfInsurance.maxage,
            gender: this.typesOfInsurance.gender,
            position: this.typesOfInsurance.position ?
              this.typesOfInsurance.position : []
          }
          if (!this.typesOfInsurance.job) {
            d.position = null;
          }
          if (!this.typesOfInsurance.age) {
            d.minage = null;
            d.maxage = null;
          }
          if (!this.typesOfInsurance.sex) {
            d.gender = null;
          }
          this.insuranceTypesList.push(d);
          this.typesOfInsurance = {
            value: '',
            text: '',
            minage: null,
            maxage: null,
            gender: null, //性别1：男2：女（未勾选不要传
            position: '',
            sex: false,
            age: false,
            job: false,
          };
        }
      },
      //删除行
      delItem(list, i) {
        list.splice(i, 1)
      },
      //添加参保岗位和职业类别设置
      addRule2() {
        if (!this.jobAndCategory.value) {
          this.$message.warning('请选择职业类别！');
        } else if (!this.jobAndCategory.sex && !this.jobAndCategory.age && !this.jobAndCategory.job) {
          this.$message.warning('请至少勾选一个条件！');
        } else {
          let d = {
            value: this.jobAndCategory.value,
            text: this.jobAndCategory.text,
            minage: this.jobAndCategory.minage,
            maxage: this.jobAndCategory.maxage,
            gender: this.jobAndCategory.gender,
            position: this.jobAndCategory.position ?
              this.jobAndCategory.position : []
          }
          if (!this.jobAndCategory.job) {
            d.position = null;
          }
          if (!this.jobAndCategory.age) {
            d.minage = null;
            d.maxage = null;
          }
          if (!this.jobAndCategory.sex) {
            d.gender = null;
          }
          this.jobAndCategoryList.push(d);
          this.jobAndCategory = {
            value: '',
            text: '',
            minage: null,
            maxage: null,
            gender: null, //性别1：男2：女（未勾选不要传
            position: '',
            sex: false,
            age: false,
            job: false,
          };
        }
      },
      addRule3() {
        if (!this.employeeAttribute.value) {
          this.$message.warning('请选择员工属性！');
        } else if (!this.employeeAttribute.sex && !this.employeeAttribute.age && !this.employeeAttribute.job) {
          this.$message.warning('请至少勾选一个条件！');
        } else {
          let d = {
            value: this.employeeAttribute.value,
            text: this.employeeAttribute.text,
            minage: this.employeeAttribute.minage,
            maxage: this.employeeAttribute.maxage,
            gender: this.employeeAttribute.gender,
            position: this.employeeAttribute.position ?
              this.employeeAttribute.position : []
          }
          if (!this.employeeAttribute.job) {
            d.position = null;
          }
          if (!this.employeeAttribute.age) {
            d.minage = null;
            d.maxage = null;
          }
          if (!this.employeeAttribute.sex) {
            d.gender = null;
          }
          this.employeeAttributeList.push(d);
          this.employeeAttribute = {
            value: '',
            text: '',
            minage: null,
            maxage: null,
            gender: null, //性别1：男2：女（未勾选不要传
            position: '',
            sex: false,
            age: false,
            job: false,
          };
        }
      },
      //新增商保、电子签规则
      confirmAdd() {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            this.isbtnLoading = true;
            let d = JSON.parse(JSON.stringify(this.ruleForm));
            d.typesOfInsurance = JSON.stringify(d.typesOfInsurance);
            d.jobAndCategory = JSON.stringify(d.jobAndCategory);
            d.employeeAttribute = JSON.stringify(d.employeeAttribute);
            xz.RPAFun(d, 'CreateOrEditBaseTogetEntry').then(res => {
              if (res.status == 'ok') {
                this.getList();
                this.isbtnLoading = false;
                this.$message.success('保存成功');
                this.addVisible = false;
                this.addEleVisible = false;
              } else {
                this.isbtnLoading = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      //入职签约规则
      addEleSet() {
        this.ruleForm = {
          projectId: null,
          signingCompany: '', //签约公司
          templateId: '', //默认模板id
          templateName: '',
          agreementType: '', //默认合同协议类型
          deadline: null, //默认合同期限
          unit: null, //默认合同期限单位
          userId: Cookies.get("userid-b"),
          lTemplateId: '', //离职默认模板id
          lTemplateName: '', //离职默认模板名称
          lAgreementType: '' //离职默认合同协议类型
        }
        this.isbtnLoading = false;
        this.addEleVisible = true;
      },
      //新增入职签约规则 行
      addRule4() {
        if (!this.typesOfInsurance.signingCompany && this.type == 'entry') {
          this.$message.warning('请选择签约主体！');
          return
        } else if (!this.typesOfInsurance.templateId) {
          this.$message.warning('请选择签约模板！');
          return
        } else if (!this.typesOfInsurance.templateName) {
          this.$message.warning('请选择合同/协议类型！');
          return
        } else if (!this.typesOfInsurance.sex && !this.typesOfInsurance.age && !this.typesOfInsurance.job && !this.typesOfInsurance.work) {
          this.$message.warning('请至少勾选一个条件！');
        } else {
          let d = JSON.parse(JSON.stringify(this.typesOfInsurance));
          if (this.typesOfInsurance.job) {
            d.position = d.position ?
              d.position : []
          } else {
            d.position = null;
          }
          if (!this.typesOfInsurance.age) {
            d.minage = null;
            d.maxage = null;
          }
          if (!this.typesOfInsurance.sex) {
            d.gender = null;
          }
          if (!this.typesOfInsurance.work) {
            d.workType = null;
          }

          if (this.type == 'entry') {
            this.ruleForm.conditions.push(d);
          } else {
            this.ruleForm.data.push(d);
          }
          this.typesOfInsurance = {
            signingCompany: '',
            templateId: '',
            templateName: '',
            agreementType: '',
            deadline: null,
            unit: null,
            minage: null,
            maxage: null,
            gender: null, //性别1：男2：女（未勾选不要传
            position: '',
            sex: false,
            age: false,
            job: false,
            work: false
          }
        }
      },
      // 修改入职签约规则
      editEleHandel(row) {
        let str = `GetSigningRules?ProjectId=${row.projectId}`;
        xz.TaskSetupGetFun(str).then(res => {
          if (res.status == 'ok') {
            this.ruleForm = res.data;
            this.changePro();
            this.ruleForm.userId = Cookies.get("userid-b");
            this.typesOfInsurance = {
              signingCompany: '',
              templateId: '',
              templateName: '',
              agreementType: '',
              deadline: null,
              unit: null,
              minage: null,
              maxage: null,
              gender: null, //性别1：男2：女（未勾选不要传
              position: '',
              sex: false,
              age: false,
              job: false,
              work: false
            };
            this.insuranceTypesList = res.data.conditions;
            let d = {
              signingCompany: res.data.signingCompany,
              templateName: res.data.templateName,
              agreementType: res.data.agreementType,
              deadline: res.data.deadline,
              unit: res.data.unit,
              conditionsId: res.data.conditionsId,
            }
            this.insuranceTypesList.unshift(d);
            this.getJobData(res.data.projectId);
            this.type = 'entry';
            this.editEleVisible = true;
          } else {}
        })
      },
      // 修改离职职签约规则
      editQuitHandel(row) {
        let str = `GetResignationSigningEdit?ProjectId=${row.projectId}`;
        xz.TaskSetupGetFun(str).then(res => {
          if (res.status == 'ok') {
            this.ruleForm = res.data;
            this.changePro();
            this.ruleForm.userId = Cookies.get("userid-b");
            this.typesOfInsurance = {
              templateId: '',
              templateName: '',
              agreementType: '',
              minage: null,
              maxage: null,
              gender: null, //性别1：男2：女（未勾选不要传
              position: '',
              sex: false,
              age: false,
              job: false,
            };
            this.insuranceTypesList = res.data.data;
            let d = {
              templateName: res.data.templateName,
              agreementType: res.data.agreementType,
            }
            this.insuranceTypesList.unshift(d);
            this.type = 'quit';
            this.getJobData(res.data.projectId);
            this.editEleVisible = true;
          } else {}
        })
      },
      changeTemp(val) {
        if (val) {
          let item = this.tempList.find(e => e.TempId == val)
          this.ruleForm.templateName = item.TempName;
          console.log(this.ruleForm.templateName)
        }
      },
      changeTemp2(val) {
        if (val) {
          let item = this.tempList.find(e => e.TempId == val)
          this.ruleForm.lTemplateName = item.TempName;
        }
      },
      changeTemp3(val) {
        if (val) {
          let item = this.tempList.find(e => e.TempId == val)
          this.typesOfInsurance.templateName = item.TempName;
        }
      },
      //确认修改入职签约规则
      confirmEditEleSet() {
        if (this.typesOfInsurance.signingCompany && this.typesOfInsurance.templateId && this.typesOfInsurance.agreementType && this.typesOfInsurance.deadline && this.typesOfInsurance.unit) {
          this.addRule4();
        }
        this.ruleForm.conditions = JSON.parse(JSON.stringify(this.insuranceTypesList));
        this.ruleForm.conditions.shift();
        this.isbtnLoading = false;
        xz.TaskSetupFun(this.ruleForm, 'SetsigningRulesEdit').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.isbtnLoading = false;
            this.$message.success('保存成功！');
            this.editEleVisible = false;
          } else {
            this.isbtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      //确认修改离职职签约规则
      confirmEditQuitSet() {
        if (this.typesOfInsurance.templateId && this.typesOfInsurance.agreementType) {
          this.addRule4();
        }
        this.ruleForm.data = JSON.parse(JSON.stringify(this.insuranceTypesList));
        this.ruleForm.data.shift();
        this.isbtnLoading = false;
        xz.TaskSetupFun(this.ruleForm, 'SetResignationSigningSave').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.isbtnLoading = false;
            this.$message.success('保存成功！');
            this.editEleVisible = false;
          } else {
            this.isbtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      fieldSet(row) {
        this.fieldSetForm = {
          type: this.type == 'quit' ? 2 : 1, //类型1：入职2：离职
          conditionsId: row.conditionsId,
          data: [],
        }
        this.isbtnLoading = false;
        let data = {
          agreements: [row.agreementType]
        }
        xz.TaskSetupFun(data, 'GetProtocolField').then(res => {
          if (res.status == 'ok') {
            this.fieldData = Object.entries(res.data).map(([key, values]) => ({
              key,
              item1: values.item1,
              item2: values.item2
            }));
            this.fieldForm = {
              projectId: row.projectId,
              data: []
            }

            let str = `GetSigningFieldEdit?Type=${this.fieldSetForm.type}&ConditionsId=${row.conditionsId}`;
            xz.TaskSetupGetFun(str).then(r => {
              if (r.status == 'ok') {
                if (r.data != undefined && r.data.data.length > 0) {
                  this.fieldData.forEach((e, i) => {
                    let d = r.data.data.find(k => k.fieldNo == e.key);
                    this.fieldForm.data.push(d)

                    this.changeSource(d.source, this.fieldData[i])
                  })
                } else {
                  this.fieldData.forEach(e => {
                    let d = {
                      fieldNo: e.item1,
                      source: null,
                      dataSourceNo: null,
                      inputContent: ''
                    }
                    this.fieldForm.data.push(d);
                  });
                }
              }
            })
            console.log(this.fieldForm.data, this.fieldData)
            this.showFieldSet = true;
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      //获取label名称
      getLabel(val) {
        let list = ['输入', '人员实名信息', '项目信息', '入职信息', '主体信息'];
        return list[val - 1]
      },
      //获取来源 2/3 下拉选项
      GetDataSourceNo(val, list) {
        let str = `GetDataSourceNo?Source=${val}`;
        xz.TaskSetupGetFun(str).then(res => {
          if (res.status == 'ok') {
            this[list] = res.data;
          } else {
            this[list] = []
          }
        })
      },
      changeSource(val, item) {
        let d = item.item2.find(e => e.source == val)
        try {
          if (d.inputType == "select") {
            this.$set(item, 'dic', d.dic)
          }
          this.$set(item, 'inputType', d.inputType)
        } catch (e) {
          console.log(e)
        }

      },
      confirmSetField() {
        this.isbtnLoading = true;
        this.fieldSetForm.data = JSON.parse(JSON.stringify(this.fieldForm.data))
        xz.TaskSetupFun(this.fieldSetForm, 'SetSigningFieldSave').then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功');
            this.showFieldSet = false;
            this.getList();
            this.isbtnLoading = false;
          } else {
            this.isbtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      changeSubjectType() {
        if (this.ruleForm.subjectType == 1) {
          this.ruleForm.subjectId = '';
        }
      },
      // 根据ID获取法务主体名称
      getLegalSubjectName(id) {
        if (!id) return '';
        const item = this.legList.find(item => item.Id == id);
        return item ? item.CompanyName : id; // 如果找不到返回原值或空字符串
      },
      getJobData(projectid) {
        let str = `Project/GetProjectPositionList?ProjectId=${projectid}`
        xz.rcGetFun(str).then(res => {
          if (res.status == 'ok') {
            this.jobData = res.data;
          } else {
            this.jobData = [];
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .formTitle {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 15px;
    margin-top: 20px;
  }

  .formTitle span {
    color: #F59A23;
    font-size: 18px;
  }

  .setItem {
    margin-top: 10px;
  }

  .yearBox {
    height: 32px;
    line-height: 32px;
    margin-bottom: 10px;
  }

  .icon01 {
    color: #19bd92;
    font-size: 20px;
    cursor: pointer;
  }

  .icon02 {
    // color: #19bd92;
    font-size: 20px;
    cursor: pointer;
    margin-left: 5px;
    line-height: 32px;
  }

  .addBox {
    height: 32px;
    line-height: 32px;
  }

  .personnelCondition {
    font-weight: bold;
  }

  .table-header {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    background: #fafafa;
    padding: 12px 16px;
    border-bottom: 1px solid #e8e8e8;
    font-weight: bold;
  }

  .field-row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 12px 16px;
    border-bottom: 1px solid #e8e8e8;
    align-items: center;
  }

  .tips {
    color: #D69014;
    margin-left: 20px;
    font-size: 12px;
  }

  .cell_newline {
    white-space: pre-wrap;
    /* 保留空白符序列，但是正常地进行换行 */
    word-break: break-all;
    /* 允许在单词内换行 */
    line-height: 2;
    /* 可选：增加行高以提高可读性 */
  }
</style>
<style>
  .page_ruleSet .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_ruleSet .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_ruleSet .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_ruleSet .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_ruleSet .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_ruleSet .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>